var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M7.14886 0.895706C8.55081 -0.12287 10.4492 -0.122872 11.8511 0.895704L17.1349 4.73462C18.5369 5.75319 19.1235 7.55866 18.588 9.20675L16.5698 15.4182C16.0343 17.0663 14.4985 18.1822 12.7656 18.1822H6.23442C4.50152 18.1822 2.9657 17.0663 2.4302 15.4182L0.411963 9.20676C-0.123534 7.55867 0.463098 5.75319 1.86505 4.73462L7.14886 0.895706Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon3);
export default __webpack_public_path__ + "static/media/polygon-3.a5eb9285517d9e92716a09cc82ba8dfd.svg";
export { ForwardRef as ReactComponent };